(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var REMOVE_ICON =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>';

    function formatMoney(cents, root) {
      var currency = root.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var locale = root.dataset.locale || document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function showStatus(root, message, isError) {
      var el = root.querySelector('[data-bundle-status]');
      if (!el) return;
      el.textContent = message;
      el.classList.toggle('bundle-builder__status--error', !!isError);
      el.classList.remove('d-none');
      clearTimeout(el._timer);
      el._timer = setTimeout(function () {
        el.classList.add('d-none');
        el.textContent = '';
      }, 4000);
    }

    function updateHeaderCount() {
      return fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          document
            .querySelectorAll('.cart-count, .cart-item-count, .cart__count, [data-cart-count], [data-cart-item-count], .open-cart-drawer a > span:last-child, #cart-count, .header__cart-count, .cart-count-bubble')
            .forEach(function (el) {
              el.textContent = count;
              if (count > 0) {
                el.removeAttribute('hidden');
                el.classList.remove('d-none', 'hidden', 'is-hidden');
              }
            });
          return cart;
        })
        .catch(function () {});
    }

    function openCart(root) {
      var cartType = root.dataset.cartType || 'drawer';
      if (cartType === 'page') {
        window.location.href = root.dataset.cartUrl || '/cart';
        return;
      }
      var drawer = document.getElementById('cartOffCanvas');
      if (drawer && window.bootstrap && window.bootstrap.Offcanvas) {
        (bootstrap.Offcanvas.getInstance(drawer) || new bootstrap.Offcanvas(drawer)).show();
        return;
      }
      var icon = document.getElementById('cart-icon');
      if (icon) icon.click();
    }

    function BundleBuilder(root) {
      this.root = root;
      this.size = parseInt(root.dataset.bundleSize, 10) || 3;
      this.discount = parseInt(root.dataset.bundleDiscount, 10) || 0;
      this.allowDuplicates = root.dataset.allowDuplicates !== 'false';
      this.items = [];
      this.slots = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-slot]'));
      this.submitBtn = root.querySelector('[data-bundle-submit]');
      var submitLabelEl = root.querySelector('[data-bundle-submit-label]');
      this.submitLabel = submitLabelEl ? submitLabelEl.textContent.trim() : '';
      this.slotsEl = root.querySelector('[data-bundle-slots]');
      this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-dot]'));
      this.storageKey = 'bundle-builder:' + (root.dataset.sectionId || '');
      this.init();
    }

    BundleBuilder.prototype.save = function () {
      try {
        if (this.items.length) localStorage.setItem(this.storageKey, JSON.stringify(this.items));
        else localStorage.removeItem(this.storageKey);
      } catch (e) {}
    };

    BundleBuilder.prototype.restore = function () {
      var self = this;
      var saved;
      try {
        saved = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
      } catch (e) {
        return;
      }
      if (!Array.isArray(saved)) return;

      saved.forEach(function (item) {
        if (!item || self.isFull()) return;
        var variantId = parseInt(item.variantId, 10);
        var card = self.root.querySelector('[data-bundle-card][data-product-id="' + item.productId + '"]');
        if (!variantId || !card) return;

        var priceCents;
        var priceFormatted;
        var select = card.querySelector('[data-bundle-variant-select]');
        if (select) {
          var opt = select.querySelector('option[value="' + variantId + '"]');
          if (!opt || opt.dataset.available !== 'true') return;
          priceCents = opt.dataset.priceCents;
          priceFormatted = opt.dataset.price;
        } else {
          var btn = card.querySelector('[data-bundle-add]');
          if (!btn || parseInt(btn.dataset.variantId, 10) !== variantId || btn.hasAttribute('disabled')) return;
          priceCents = btn.dataset.priceCents;
          priceFormatted = btn.dataset.price;
        }

        var duplicate = self.items.some(function (i) {
          return i.variantId === variantId || (!self.allowDuplicates && i.productId === item.productId);
        });
        if (duplicate) return;

        self.items.push({
          variantId: variantId,
          productId: item.productId,
          title: item.title || card.dataset.productTitle || '',
          url: item.url || card.dataset.productUrl || '#',
          variantTitle: item.variantTitle || '',
          priceCents: parseInt(priceCents, 10) || 0,
          priceFormatted: priceFormatted || '',
          image: item.image || card.dataset.productImage || ''
        });
      });
    };

    BundleBuilder.prototype.init = function () {
      var self = this;

      this.root.querySelectorAll('[data-bundle-card]').forEach(function (card) {
        var select = card.querySelector('[data-bundle-variant-select]');
        var btn = card.querySelector('[data-bundle-add]');
        if (!btn) return;

        if (select) {
          select.addEventListener('change', function () {
            self.onVariantChange(card, select, btn);
          });
        }
        btn.addEventListener('click', function () {
          self.add(card, btn);
        });
      });

      this.root.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-bundle-remove]');
        if (!removeBtn) return;
        e.preventDefault();
        self.remove(parseInt(removeBtn.dataset.bundleRemove, 10));
      });

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', function () {
          self.submit();
        });
      }

      this.initSlider();
      this.restore();
      this.render();
    };

    BundleBuilder.prototype.isSlider = function () {
      return !!this.slotsEl && this.slotsEl.scrollWidth > this.slotsEl.clientWidth;
    };

    BundleBuilder.prototype.scrollToSlot = function (index) {
      var slot = this.slots[index];
      if (!slot || !this.isSlider()) return;
      this.slotsEl.scrollTo({ left: slot.offsetLeft - this.slots[0].offsetLeft, behavior: 'smooth' });
    };

    BundleBuilder.prototype.initSlider = function () {
      var self = this;
      if (!this.slotsEl || !this.dots.length) return;

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.scrollToSlot(parseInt(dot.dataset.bundleDot, 10));
        });
      });

      var ticking = false;
      this.slotsEl.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var start = self.slots[0].offsetLeft;
            var left = self.slotsEl.scrollLeft;
            var active = 0;
            self.slots.forEach(function (slot, idx) {
              if (Math.abs(slot.offsetLeft - start - left) < Math.abs(self.slots[active].offsetLeft - start - left)) active = idx;
            });
            self.dots.forEach(function (dot, idx) {
              dot.classList.toggle('is-active', idx === active);
            });
          });
        },
        { passive: true }
      );
    };

    BundleBuilder.prototype.onVariantChange = function (card, select, btn) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var available = opt.dataset.available === 'true';

      btn.dataset.variantId = opt.value;
      btn.dataset.variantTitle = opt.dataset.title || '';
      btn.dataset.priceCents = opt.dataset.priceCents || '0';
      btn.dataset.price = opt.dataset.price || '';
      if (opt.dataset.image) card.dataset.variantImage = opt.dataset.image;
      else delete card.dataset.variantImage;

      var current = card.querySelector('[data-bundle-price-current]');
      var compare = card.querySelector('[data-bundle-price-compare]');
      if (current) {
        current.textContent = opt.dataset.price || '';
        current.classList.toggle('sale_price', !!opt.dataset.comparePrice);
        current.classList.toggle('regular_price', !opt.dataset.comparePrice);
      }
      if (compare) {
        compare.textContent = opt.dataset.comparePrice || '';
        compare.hidden = !opt.dataset.comparePrice;
      }

      card.dataset.unavailable = available ? '' : 'true';
      this.syncButtons();
    };

    BundleBuilder.prototype.isFull = function () {
      return this.items.length >= this.size;
    };

    BundleBuilder.prototype.add = function (card, btn) {
      if (this.isFull()) return;
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      var productId = card.dataset.productId;
      var alreadyVariant = this.items.some(function (i) { return i.variantId === variantId; });
      var alreadyProduct = this.items.some(function (i) { return i.productId === productId; });
      if (alreadyVariant || (!this.allowDuplicates && alreadyProduct)) return;

      this.items.push({
        variantId: variantId,
        productId: productId,
        title: card.dataset.productTitle || '',
        url: card.dataset.productUrl || '#',
        variantTitle: btn.dataset.variantTitle || '',
        priceCents: parseInt(btn.dataset.priceCents, 10) || 0,
        priceFormatted: btn.dataset.price || '',
        image: card.dataset.variantImage || card.dataset.productImage || ''
      });

      this.render();
      this.scrollToSlot(this.items.length - 1);
    };

    BundleBuilder.prototype.remove = function (index) {
      if (isNaN(index) || index < 0 || index >= this.items.length) return;
      this.items.splice(index, 1);
      this.render();
    };

    BundleBuilder.prototype.reset = function () {
      this.items = [];
      this.render();
    };

    BundleBuilder.prototype.syncButtons = function () {
      var self = this;
      var full = this.isFull();
      var t = this.root.dataset;

      this.root.querySelectorAll('[data-bundle-card]').forEach(function (card) {
        var btn = card.querySelector('[data-bundle-add]');
        if (!btn) return;
        var label = btn.querySelector('[data-bundle-add-label]');
        var variantId = parseInt(btn.dataset.variantId, 10);
        var productId = card.dataset.productId;
        var unavailable = card.dataset.unavailable === 'true';

        var inBundle = self.items.some(function (i) {
          return i.variantId === variantId || (!self.allowDuplicates && i.productId === productId);
        });

        btn.classList.toggle('is-added', inBundle);
        btn.disabled = unavailable || inBundle || full;
        if (label) {
          label.textContent = unavailable ? t.textSold : inBundle ? t.textAdded : t.textAdd;
        }
      });
    };

    BundleBuilder.prototype.renderSlots = function () {
      var self = this;
      var t = this.root.dataset;

      this.slots.forEach(function (slot, idx) {
        var item = self.items[idx];
        var thumb = slot.querySelector('[data-bundle-slot-thumb]');
        var body = slot.querySelector('[data-bundle-slot-body]');
        slot.classList.toggle('bundle-builder__slot--filled', !!item);

        if (!item) {
          thumb.innerHTML = '';
          body.innerHTML =
            '<span class="bundle-builder__skeleton bundle-builder__skeleton--long"></span>' +
            '<span class="bundle-builder__skeleton bundle-builder__skeleton--short"></span>';
          var existing = slot.querySelector('[data-bundle-remove]');
          if (existing) existing.remove();
          return;
        }

        thumb.innerHTML = '';
        var thumbLink = document.createElement('a');
        thumbLink.href = item.url;
        thumbLink.className = 'bundle-builder__slot-thumb-link';
        thumbLink.tabIndex = -1;
        thumbLink.setAttribute('aria-hidden', 'true');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 110;
          img.height = 110;
          thumbLink.appendChild(img);
        } else {
          var placeholder = self.root.querySelector('[data-bundle-placeholder]');
          if (placeholder) thumbLink.appendChild(placeholder.content.cloneNode(true));
        }
        thumb.appendChild(thumbLink);

        var titleEl = document.createElement('div');
        titleEl.className = 'bundle-builder__slot-title';
        var link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        titleEl.appendChild(link);

        body.innerHTML = '';
        body.appendChild(titleEl);

        if (item.variantTitle) {
          var variantEl = document.createElement('div');
          variantEl.className = 'bundle-builder__slot-variant';
          variantEl.textContent = item.variantTitle;
          body.appendChild(variantEl);
        }

        var priceEl = document.createElement('div');
        priceEl.className = 'bundle-builder__slot-price';
        priceEl.textContent = item.priceFormatted || formatMoney(item.priceCents, self.root);
        body.appendChild(priceEl);

        var removeBtn = slot.querySelector('[data-bundle-remove]');
        if (!removeBtn) {
          removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bundle-builder__slot-remove';
          removeBtn.innerHTML = REMOVE_ICON;
          slot.appendChild(removeBtn);
        }
        removeBtn.dataset.bundleRemove = idx;
        removeBtn.setAttribute('aria-label', t.textRemove + ' ' + item.title);
      });
    };

    BundleBuilder.prototype.renderTotals = function () {
      var subtotal = this.items.reduce(function (sum, i) { return sum + i.priceCents; }, 0);
      var complete = this.items.length === this.size && this.size > 0;
      var discounted = complete && this.discount > 0 ? Math.round(subtotal * (100 - this.discount) / 100) : subtotal;

      var totalEl = this.root.querySelector('[data-bundle-total]');
      var compareEl = this.root.querySelector('[data-bundle-compare]');
      var savingEl = this.root.querySelector('[data-bundle-saving]');
      var savingAmountEl = this.root.querySelector('[data-bundle-saving-amount]');

      if (totalEl) totalEl.textContent = formatMoney(discounted, this.root);
      if (compareEl) {
        compareEl.hidden = !(complete && this.discount > 0);
        compareEl.textContent = formatMoney(subtotal, this.root);
      }
      if (savingEl) {
        savingEl.hidden = !(complete && this.discount > 0);
        if (savingAmountEl) savingAmountEl.textContent = formatMoney(subtotal - discounted, this.root);
      }
    };

    BundleBuilder.prototype.renderProgress = function () {
      var t = this.root.dataset;
      var bar = this.root.querySelector('[data-bundle-progress]');
      var text = this.root.querySelector('[data-bundle-progress-text]');
      var pct = this.size ? Math.round((this.items.length / this.size) * 100) : 0;
      if (bar) {
        bar.style.width = pct + '%';
        bar.setAttribute('aria-valuenow', this.items.length);
      }
      if (text) {
        text.textContent = this.isFull()
          ? t.textComplete
          : (t.textProgress || '').replace('[count]', this.items.length).replace('[total]', this.size);
      }
      if (this.submitBtn) this.submitBtn.disabled = !this.isFull();
    };

    BundleBuilder.prototype.render = function () {
      this.renderSlots();
      this.renderTotals();
      this.renderProgress();
      this.syncButtons();
      this.save();
    };

    BundleBuilder.prototype.setBusy = function (busy) {
      var t = this.root.dataset;
      var label = this.root.querySelector('[data-bundle-submit-label]');
      var spinner = this.root.querySelector('[data-bundle-spinner]');
      if (!this.submitBtn) return;
      this.submitBtn.disabled = busy || !this.isFull();
      if (label) label.textContent = busy ? t.textAdding : this.submitLabel;
      if (spinner) spinner.classList.toggle('d-none', !busy);
    };

    BundleBuilder.prototype.submit = function () {
      var self = this;
      if (!this.isFull() || this.busy) return;
      var t = this.root.dataset;

      var items = this.items.map(function (i) {
        return { id: i.variantId, quantity: 1 };
      });

      this.busy = true;
      this.setBusy(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || t.textError);
            return data;
          });
        })
        .then(function () {
          return updateHeaderCount();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('bundle:items-added', { detail: { items: items } }));
          self.reset();
          showStatus(self.root, t.textSuccess, false);
          openCart(self.root);
        })
        .catch(function (err) {
          showStatus(self.root, (err && err.message) || t.textError, true);
        })
        .finally(function () {
          self.busy = false;
          self.setBusy(false);
        });
    };

    function boot(scope) {
      (scope || document).querySelectorAll('[data-bundle-builder]').forEach(function (root) {
        if (root.dataset.bundleBooted === 'true') return;
        root.dataset.bundleBooted = 'true';
        root._bundleBuilder = new BundleBuilder(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        boot(e.target);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["number-counter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.number-counter-value');
    const updateCounter = (counter) => {
      const target = +counter.getAttribute('data-value');
      counter.innerText = '0';
      const increment = target / 200;

      const countUp = () => {
        const current = +counter.innerText;
        if (current < target) {
          counter.innerText = Math.ceil(current + increment);
          setTimeout(countUp, 5);
        } else {
          counter.innerText = target;
        }
      };

      countUp();
    };
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          updateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // ─── Helpers ────────────────────────────────────────────────────────────────

    /** Returns the currently visible quantity input for a row (desktop or mobile). */
    function getVisibleQtyInput(row) {
      const inputs = row.querySelectorAll('[data-quick-order-quantity]');
      for (const input of inputs) {
        if (input.offsetParent !== null) return input;
      }
      return inputs[0] || null;
    }

    /** Syncs all qty inputs in a row to the same value. */
    function syncQtyInputs(row, value) {
      row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.value = value;
      });
    }

    /** Updates availability state of a row (checkbox + all qty inputs). */
    function setRowAvailability(row, available) {
      row.dataset.quickOrderRowAvailable = String(available);

      const checkbox = row.querySelector('[data-quick-order-checkbox]');
      row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.disabled = !available;
        if (!available) input.value = '1';
      });

      if (checkbox) {
        checkbox.disabled = !available;
        if (!available) checkbox.checked = false;
      }
    }

    function setSubmitState(form) {
      const btn = form.querySelector('[data-quick-order-submit]');
      if (!btn) return;
      const hasChecked = !!form.querySelector('[data-quick-order-checkbox]:checked');
      btn.disabled = !hasChecked;
      btn.style.cursor = hasChecked ? '' : 'not-allowed';
      btn.style.opacity = hasChecked ? '' : '0.5';
    }

    /** Rebuilds the "N items selected (qty)" summary line. */
    function updateSummary(form) {
      const summary = form.querySelector('[data-quick-order-summary]');
      if (!summary) return;

      let totalProducts = 0;
      let totalQty = 0;

      form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
        const checkbox = row.querySelector('[data-quick-order-checkbox]');
        const input = getVisibleQtyInput(row);
        if (!checkbox?.checked || !input) return;
        totalProducts++;
        totalQty += parseInt(input.value, 10) || 0;
      });

      const label =
        totalProducts === 1
          ? form.dataset.product
          : form.dataset.products;

      const next = `${totalProducts} ${label} ${form.dataset.selected} (${totalQty} ${form.dataset.qty})`;
      if (summary.textContent !== next) summary.textContent = next;

      setSubmitState(form);
    }

    // ─── Quantity buttons ────────────────────────────────────────────────────────

    function initQtyButtons(form) {
      form.querySelectorAll('.quantity-control').forEach((wrapper) => {
        const input = wrapper.querySelector('[data-quick-order-quantity]');
        const incBtn = wrapper.querySelector('.quanity_increment');
        const decBtn = wrapper.querySelector('.quanity_descrement');
        if (!input) return;

        function step(delta) {
          if (input.disabled) return;
          let val = parseInt(input.value, 10) || 1;
          const max = parseInt(input.max, 10);
          if (delta > 0 && !isNaN(max) && val >= max) {
          const row = input.closest('[data-quick-order-row]');
          if (row) {
            showRowError(row, `Only ${max} item${max > 1 ? 's are' : ' is'} available.`);
          }
          return;
        }
          if (delta < 0 && val <= 1) return;
          val += delta;

          const row = input.closest('[data-quick-order-row]');
          row ? syncQtyInputs(row, val) : (input.value = val);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Click
        incBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          step(1);
        });
        decBtn?.addEventListener('click', (e) => {
          e.preventDefault();
          step(-1);
        });

        // Keyboard (Enter / Space) — accessibility
        [incBtn, decBtn].forEach((btn) => {
          if (!btn) return;
          btn.setAttribute('role', 'button');
          btn.setAttribute('tabindex', '0');
          btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              step(btn.classList.contains('quanity_increment') ? 1 : -1);
            }
          });
        });
      });
    }

    // ─── Variant select ──────────────────────────────────────────────────────────

    function initVariantSelects(form) {
      form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
        const select = row.querySelector('[data-quick-order-variant-select]');
        if (!select) return;

        select.addEventListener('change', () => {
          const opt = select.options[select.selectedIndex];
          const variantId = opt.value;
          const available = opt.dataset.available === 'true';

          // Update variant ID on every qty input in this row
          row.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
            input.dataset.quickOrderVariantId = variantId;
          });

          // Update price display
          const priceEl = row.querySelector('[data-quick-order-price]');

          if (priceEl) {
            const sale = priceEl.querySelector('.price-sale, .price');
            const compare = priceEl.querySelector('.price-compare');

            if (sale) {
              sale.textContent = opt.dataset.price;
            }

            if (compare) {
              if (opt.dataset.comparePrice) {
                compare.textContent = opt.dataset.comparePrice;
                compare.style.display = '';
              } else {
                compare.style.display = 'none';
              }
            }
          }

          setRowAvailability(row, available);
          updateSummary(form);
        });
      });
    }


    function clearRowError(row) {
        const el = row.querySelector('[data-quick-order-row-error]');
        if (!el) return;

        el.classList.add('d-none');
        el.innerHTML = '';
      }

      function showRowError(row, message) {
        const el = row.querySelector('[data-quick-order-row-error]');
        if (!el) return;

        el.innerHTML = `
          <svg width="12" height="12" viewBox="0 0 24 24" fill="#dc2626" aria-hidden="true">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.0586 6.05547C10.0268 5.48227 10.483 5 11.0571 5H12.9429C13.517 5 13.9732 5.48227 13.9414 6.05547L13.5525 13.0555C13.523 13.5854 13.0847 14 12.554 14H11.446C10.9153 14 10.477 13.5854 10.4475 13.0555L10.0586 6.05547ZM14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z"/>
          </svg>
          <span>${message}</span>
        `;

        el.classList.remove('d-none');

        setTimeout(() => {
          clearRowError(row);
        }, 3000);
      }

    // ─── Form submit ─────────────────────────────────────────────────────────────

    function initSubmit(form) {
      const submitBtn = form.querySelector('[data-quick-order-submit]');
      const statusEl = form.querySelector('[data-quick-order-status]');
      const submitLabel = form.dataset.quickOrderSubmitLabel || submitBtn?.textContent || 'Add to cart';
      const errorMsg = form.dataset.quickOrderGenericErrorMessage || 'Something went wrong.';

      form.querySelectorAll('[data-quick-order-row]').forEach(clearRowError);

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const items = [];
        const addedRows = [];

        form.querySelectorAll('[data-quick-order-row]').forEach((row) => {
          const checkbox = row.querySelector('[data-quick-order-checkbox]');
          const input = getVisibleQtyInput(row);
          if (!checkbox?.checked || !input || input.disabled) return;

          const variantId = Number(input.dataset.quickOrderVariantId);
          const quantity = parseInt(input.value, 10) || 1;
          if (!variantId) return;

          items.push({ id: variantId, quantity });
          addedRows.push(row);
        });

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });

          if (!res.ok) {
            // Ignore Shopify quantity limit error
            try {
              const d = await res.json();
              const message = d.description || d.message || errorMsg;

              if (message.toLowerCase().includes('maximum quantity')) {
                const match = message.match(/id\s+(\d+)/i);

                if (match) {
                  const variantId = match[1];

                  const row = [...form.querySelectorAll('[data-quick-order-row]')]
                    .find(r =>
                      r.querySelector(
                        `[data-quick-order-quantity][data-quick-order-variant-id="${variantId}"]`
                      )
                    );

                  if (row) {
                    showRowError(row, message);
                    return;
                  }
                }
              }

              showStatus(form, message);
            } catch (_) {
              showStatus(form, errorMsg);
            }

            return;
          }

          let added = null;
          try {
            added = await res.json();
          } catch (_) {}


          const currencyCode = window.routes?.cart_currency || '';
          const stripCode = (text) =>
            currencyCode ? text.replace(new RegExp('\\s*' + currencyCode + '\\s*$'), '').trim() : text;
          const firstRowPrice = addedRows[0]?.querySelector('[data-quick-order-price]');
          const popupPrice = stripCode((firstRowPrice?.querySelector('.price-sale, .price')?.textContent || '').trim());
          const popupComparePrice = stripCode((firstRowPrice?.querySelector('.price-compare')?.textContent || '').trim());

          // Reset rows
          addedRows.forEach((row) => {
            syncQtyInputs(row, 1);
            const cb = row.querySelector('[data-quick-order-checkbox]');
            if (cb) cb.checked = false;
            row.classList.remove('quick-order__row--added');
            void row.offsetWidth;
            row.classList.add('quick-order__row--added');
          });

          updateSummary(form);

          // ── Update cart count badge in header ──────────────────────────
          try {
            const cartRes = await fetch('/cart.js', { cache: 'no-store' });
            const cartData = await cartRes.json();
            const count = cartData.item_count;

            // Covers the most common badge selectors across themes
            document
              .querySelectorAll(
                [
                  '.cart-count',
                  '.cart-item-count',
                  '.cart__count',
                  '[data-cart-count]',
                  '[data-cart-item-count]',
                  '.open-cart-drawer a > span:last-child',
                  '#cart-count',
                  '.header__cart-count',
                ].join(',')
              )
              .forEach((el) => {
                el.textContent = count;
                // Some themes hide the badge when 0 and show it when >0
                if (count > 0) {
                  el.removeAttribute('hidden');
                  el.classList.remove('d-none', 'hidden', 'is-hidden');
                }
              });

            // Bubble up for any theme-level cart:refresh listeners
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
          } catch (_) {}
          // ────────────────────────────────────────────────────────────────

          document.dispatchEvent(new CustomEvent('quick-order:items-added', { detail: { items } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          const cartType = form.dataset.cartType || 'drawer';

          if (cartType === 'page') {
            window.location.href = window.routes?.cart_url || '/cart';
            return;
          }

          if (cartType === 'pop_up' && added?.items?.length && typeof showSuccessPopup === 'function') {
            document.querySelectorAll('.cart-popup').forEach((el) => el.remove());
            showSuccessPopup(added.items[0], popupPrice, popupComparePrice);
            return;
          }

          // Open drawer
          const cartDrawer = document.getElementById('cartOffCanvas');
          if (cartDrawer && window.bootstrap?.Offcanvas) {
            (bootstrap.Offcanvas.getInstance(cartDrawer) || new bootstrap.Offcanvas(cartDrawer)).show();
          }
        } catch (_) {
          showStatus(form, errorMsg);
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        }
      });
    }

    // ─── Status helpers ───────────────────────────────────────────────────────────

   let statusTimeout;

      function showStatus(form, message, isError = true) {
        let el = form.querySelector('[data-quick-order-status]');

        if (!el) {
          el = document.createElement('p');
          el.dataset.quickOrderStatus = '';
          el.className = 'quick-order__status mt-2 text-center d-flex align-items-center justify-content-center gap-2';
          form.querySelector('.quick-order__actions')?.after(el);
        }

        clearTimeout(statusTimeout);

        if (isError) {
          el.innerHTML = `
            <svg width="12" height="12" viewBox="0 0 24 24" fill="#dc3545" aria-hidden="true" style="flex:0 0 auto;">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.0586 6.05547C10.0268 5.48227 10.483 5 11.0571 5H12.9429C13.517 5 13.9732 5.48227 13.9414 6.05547L13.5525 13.0555C13.523 13.5854 13.0847 14 12.554 14H11.446C10.9153 14 10.477 13.5854 10.4475 13.0555L10.0586 6.05547ZM14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17Z"
                fill="#dc3545">
              </path>
            </svg>
            <span>${message}</span>
          `;
        } else {
          el.textContent = message;
        }

        el.removeAttribute('hidden');
        el.classList.remove('d-none');

        statusTimeout = setTimeout(() => {
          el.classList.add('d-none');
          el.innerHTML = '';
        }, 3000);
      }

    function hideStatus(form) {
      const el = form.querySelector('[data-quick-order-status]');
      if (el) {
        el.textContent = '';
        el.classList.add('d-none');
      }
    }

    // ─── Boot ─────────────────────────────────────────────────────────────────────

    function bootForm(form) {
      // Prevent double-initialization
      if (form.dataset.quickOrderBooted === 'true') return;
      form.dataset.quickOrderBooted = 'true';

      // Checkbox → summary
      form.querySelectorAll('[data-quick-order-checkbox]').forEach((cb) => {
        cb.addEventListener('change', () => updateSummary(form));
      });

      // Qty input → summary (debounced)
      let tid;
      form.querySelectorAll('[data-quick-order-quantity]').forEach((input) => {
        input.addEventListener('input', () => {
          const row = input.closest('[data-quick-order-row]');
          const max = parseInt(input.max, 10);
          let value = parseInt(input.value, 10) || 1;

          if (!isNaN(max) && value > max) {
            value = max;
            syncQtyInputs(row, value);

            showRowError(
              row,
              `Only ${max} item${max > 1 ? 's are' : ' is'} available.`
            );
          } else {
            syncQtyInputs(row, value);
            clearRowError(row);
          }

          clearTimeout(tid);
          tid = setTimeout(() => updateSummary(form), 150);
        });
      });

      initQtyButtons(form);
      initVariantSelects(form);
      initSubmit(form);
      updateSummary(form);
    }

    function bootAll() {
      document.querySelectorAll('[data-quick-order-form]').forEach(bootForm);
    }

    // Initial boot
    bootAll();

    // Shopify theme customizer events
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', (e) => {
        // Section was reloaded — clear the boot flag so it re-initializes cleanly
        const form = e.target?.querySelector('[data-quick-order-form]');
        if (form) {
          delete form.dataset.quickOrderBooted;
          setTimeout(() => bootForm(form), 150);
        }
      });
      document.addEventListener('shopify:section:reorder', () => {
        setTimeout(bootAll, 150);
      });
      document.addEventListener('shopify:section:select', (e) => {
        const form = e.target?.querySelector('[data-quick-order-form]');
        if (form) setTimeout(() => updateSummary(form), 150);
      });
    }

    // Fallback for late DOM
    document.addEventListener('DOMContentLoaded', bootAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playVisibleVideos() {
      var videos = document.querySelectorAll('.video-grid video');
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      videos.forEach(function (video) {
        var rect = video.getBoundingClientRect();
        var height = rect.bottom - rect.top;
        var visible = rect.top < viewportHeight * 0.7 && rect.bottom > viewportHeight * 0.3 && height > 0;

        if (visible) {
          video.muted = true;
          video.autoplay = true;
          video.playsInline = true;

          if (video.paused) {
            video.play().catch(function () {});
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playVisibleVideos);
    } else {
      playVisibleVideos();
    }

    var scrollTimer;
    window.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(playVisibleVideos, 100);
      },
      { passive: true }
    );

    window.addEventListener('resize', playVisibleVideos);
  })();

  } catch(e) { console.error(e); }
})();
})();
